import { useMemo, useState } from 'react';
import { FiltersBar } from 'customer-data-filters-ui/public/components';
import { SegmentationFiltersUI, SegmentationFiltersInstanceProvider, SegmentationFiltersSharedProvider } from 'customer-data-filters-ui/public/subcomponents';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_CUSTOM_QUICK_FILTERS = 10;
const ReportingSegmentationFiltersBar = ({
  appUsageTracker,
  objectTypeId,
  onChange,
  onQuickFiltersChange,
  onUserAddedQuickFilterChange,
  quickFilterPropertyNames,
  quickFiltersValue,
  strategy,
  supportsOrFilters,
  userAddedQuickFilterPropertyNames,
  value,
  enableNLPPropertySearch
}) => {
  const [isAdvancedFiltersOpen, setIsAdvancedFiltersOpen] = useState(false);
  const uiMessages = useMemo(() => {
    return {
      viewerEmptyFilters: I18n.text('reporting-enablement.reportEditors.filterPlaceholders.viewerEmptyFilters'),
      quickFiltersDescription: I18n.text('reporting-enablement.reportEditors.filterPlaceholders.quickFiltersDescription')
    };
  }, []);
  return /*#__PURE__*/_jsxs(SegmentationFiltersSharedProvider, {
    strategy: strategy,
    trackerInstance: appUsageTracker,
    children: [/*#__PURE__*/_jsx(FiltersBar, {
      filterFamily: objectTypeId,
      defaultPropertyNames: quickFilterPropertyNames,
      advancedFiltersValue: value,
      onOpenAdvancedFilters: () => setIsAdvancedFiltersOpen(!isAdvancedFiltersOpen),
      customPropertyNames: userAddedQuickFilterPropertyNames,
      onCustomPropertyNamesChange: onUserAddedQuickFilterChange,
      value: quickFiltersValue,
      onChange: onQuickFiltersChange,
      maxCustomQuickFilters: MAX_CUSTOM_QUICK_FILTERS
    }), /*#__PURE__*/_jsx(SegmentationFiltersInstanceProvider, {
      baseFilterFamily: objectTypeId,
      closePanel: () => setIsAdvancedFiltersOpen(false),
      isAndGroup: !supportsOrFilters,
      layout: "panel",
      onChange: onChange,
      onQuickFiltersChange: onQuickFiltersChange,
      quickFilters: quickFiltersValue,
      value: value,
      uiMessages: uiMessages,
      enableNLPPropertySearchForReporting: enableNLPPropertySearch,
      children: isAdvancedFiltersOpen && /*#__PURE__*/_jsx(SegmentationFiltersUI, {})
    })]
  });
};
export default ReportingSegmentationFiltersBar;